import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface ArrayBadgeCellRendererValue {
    values?: string[];
}

@Component({
    selector: 'wdx-ag-grid-array-badge-cell-renderer',
    imports: [],
    templateUrl: './array-badge-cell-renderer.component.html',
})
export class ArrayBadgeCellRendererComponent implements ICellRendererAngularComp {
    public values: string[] = [];

    public agInit(
        params: ICellRendererParams<any, ArrayBadgeCellRendererValue>,
    ): void {
        const value = params?.value;
        this.values = value?.values ?? [];
    }

    public refresh(
        params: ICellRendererParams<any, ArrayBadgeCellRendererValue>,
    ): boolean {
        this.agInit(params);
        return true;
    }
}
